import styled from '@emotion/styled'

export const TableStyled = styled('table')({
  '& th': {
    textAlign: 'start',
  },
})
